import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';
import ForgotPassword from 'views/pages/authentication/authentication3/ForgotPassword';
import LoginRouteProtection from './LoginRouteProtection';
import { Navigate } from 'react-router-dom';

// login option 3 routing
const AuthLogin3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Login3')));
const AuthRegister3 = Loadable(lazy(() => import('views/pages/authentication/authentication3/Register3')));

// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
    path: '/',
    element: (
        <LoginRouteProtection>
            <MinimalLayout />
        </LoginRouteProtection>
    ),
    children: [
        {
            index: true,
            element: <Navigate to="pages/login/login3" replace />
        },
        {
            path: 'pages/login/login3',
            element: <AuthLogin3 />
        },
        {
            path: 'pages/register/register3',
            element: <AuthRegister3 />
        },
        {
            path: 'pages/register/forgot_password',
            element: <ForgotPassword />
        }
    ]
};

export default AuthenticationRoutes;
